/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function Introduction({ width = 19, height = 19 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 19 19.524"
    >
      <g id="Group_5123" data-name="Group 5123" transform="translate(-28 -150)">
        <path
          id="XMLID_939_"
          d="M250.5,15.549h-8.121a.429.429,0,0,0-.429.429v3.075l.839-1.244.02-.028V16.408h7.262v10.1h-7.262V22.653a2.335,2.335,0,0,1-.435.38c-.486.721-.391.58-.424.626v3.276a.429.429,0,0,0,.429.429h2.029l-1.19,3.007a.623.623,0,0,0,1.158.458l1.371-3.465h1.385L248.5,30.83a.623.623,0,1,0,1.158-.458l-1.19-3.007H250.5a.429.429,0,0,0,.429-.429V15.978A.429.429,0,0,0,250.5,15.549Z"
          transform="translate(-203.927 135.112)"
          fill="#8c8c8c"
        />
        <circle
          id="XMLID_949_"
          cx="1.607"
          cy="1.607"
          r="1.607"
          transform="translate(30.342 150)"
          fill="#8c8c8c"
        />
        <path
          id="XMLID_950_"
          d="M16.677,90.225a.775.775,0,0,0-1.068-.25l-1.57.975c0-.514,0-.915-.007-1.45A1.839,1.839,0,0,0,12.2,87.675H8.026A1.839,1.839,0,0,0,6.191,89.5l-.029,5.7a.775.775,0,0,0,.771.779h0a.775.775,0,0,0,.775-.771l.029-5.7h0a.154.154,0,0,1,.308,0v13.033a.93.93,0,0,0,1.861,0V95.306a.2.2,0,1,1,.4,0v7.236a.93.93,0,1,0,1.861,0c-.019-12.485-.017-10.838-.017-13.031a.162.162,0,0,1,.325,0h0c0,.755.012,2.373.014,2.836A.776.776,0,0,0,13.68,93l2.748-1.706A.775.775,0,0,0,16.677,90.225Z"
          transform="translate(21.837 66.051)"
          fill="#8c8c8c"
        />
      </g>
    </svg>
  );
}

export default Introduction;
